import styled from "styled-components";

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5rem;
  width: 1.5rem;
  background-color: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};

  & svg {
    display: none;
  }
`;

export const Container = styled.label<{ $disabled?: boolean }>`
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  font-size: 0.875rem;
  line-height: 1.5rem;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};

  /* On mouse-over, add a grey background color */
  &:hover ${Input} ~ ${Checkmark} {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a black background */
  & ${Input}:checked ~ ${Checkmark} {
    background-color: ${({ theme }) => theme.colors.black};
  }
  /* Show the checkmark when checked */
  & ${Input}:checked ~ ${Checkmark} svg {
    display: block;
  }

  & a {
    color: ${({ theme }) => theme.colors.red};
  }

  ${({ $disabled }) =>
    $disabled
      ? "opacity: 0.3; pointer-events: none;"
      : "opacity: 1; pointer-events: all;"}
`;
